import { WeatherTableProps } from './table';
import { WeatherBadge } from './weather-badge';
import './WeatherForecast.css';

export const WeatherSummary = ({
  weather,
  units,
}: Omit<WeatherTableProps, 'title'>) => {
  const temperaturas = weather.por_hora.map((h) => h.temperatura);

  const tempMin = Math.min(...temperaturas).toFixed(1);
  const tempMax = Math.max(...temperaturas).toFixed(1);

  return (
    <div className="weather-summary-container">
      <WeatherBadge
        icon="bi-thermometer"
        value={`${tempMin} / ${tempMax}`}
        unit={units.temperatura}
        className="bg-warning-subtle text-orange tooltip-wrapper pointer"
        data-tooltip="Temperatura Mínima / Máxima"
      />
      <WeatherBadge
        icon="bi-cloud-rain"
        value={weather.precipitacao}
        unit={units.precipitacao}
        className="bg-primary-subtle text-primary tooltip-wrapper pointer"
        data-tooltip="Precipitação Total"
      />
      <WeatherBadge
        icon="bi-wind"
        value={weather.rajada_max}
        unit={units.rajada}
        className="bg-secondary-subtle text-secondary tooltip-wrapper pointer"
        data-tooltip="Rajada Máxima de Vento"
        style={{ fontSize: '0.875rem' }}
      />
    </div>
  );
};
